import { REFERRAL_INFO, ROUTES } from '../constants/routes';
import { getFunnelSignUpLink } from '../utils/getFunnelLinks';
import { getReturnToCurrentUrlFromLogin } from '../utils/getReturnToCurrentUrlFromLogin';
import type { AppTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { QueryParams } from '../constants/QueryParams';
import { createStore } from 'reusable';
import { getBlocksTemplateUrl } from '../utils/getBlocksTemplateUrl';
import { useQueryParams } from './useQueryParams';

export const useLoginNavigation = createStore(() => {
  const { getParam } = useQueryParams();

  return (referralInfo: string, template?: AppTemplate) => {
    let postLogin: string, postSignup: string;
    const { currentUrl, encodedCurrentUrl } = getReturnToCurrentUrlFromLogin();

    if (referralInfo === REFERRAL_INFO.BLOCKS_TEMPLATE_FLOW) {
      const templateUrl = template
        ? getBlocksTemplateUrl({
            templateId: template.id,
            templateName: template.title,
            httpReferrer: getParam(QueryParams.HTTP_REFERRER),
            otherParams: { [QueryParams.RETURNED_FROM_LOGIN_PAGE]: 'true' },
          })
        : currentUrl;
      postLogin = templateUrl;
      postSignup = getFunnelSignUpLink(encodeURIComponent(templateUrl));
    } else {
      postLogin = currentUrl;
      postSignup = getFunnelSignUpLink(encodedCurrentUrl);
    }
    window.location.assign(
      ROUTES.loginPage({
        postLogin,
        postSignup,
        referralInfo,
      }),
    );
  };
});
